export default __webpack_public_path__ + "39ce771d9086e2e55ba99db66eac005c.svg";